module.exports = __webpack_public_path__ + "static/media/mode-21.7d9a2761.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-21.svg
// module id = 976
// module chunks = 2